import { ConversationIcon } from './ConversationIcon';

export default ConversationIcon;
